module.exports = __webpack_public_path__ + "static/media/header-img.4645688a.png";